import orgVendorRelActions from "./actions/orgVendorRel.js";

export default {
  ...orgVendorRelActions,
};
